import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import '@formatjs/intl-numberformat/polyfill';
import '@formatjs/intl-numberformat/locale-data/cs';
import { createRoot } from 'react-dom/client';
import BeeyApp, { Localization, useSession } from 'applib-frontend';
import StreamForm from './components/StreamForm';
import StreamTable from './components/StreamTable';
import MediaPlayer from './components/MediaPlayer';
import en from '../resources/translations/en-US.json';
import pl from '../resources/translations/pl-PL.json';
import cz from '../resources/translations/cs-CZ.json';
import de from '../resources/translations/de-DE.json';
import hr from '../resources/translations/hr-HR.json';
import sk from '../resources/translations/sk-SK.json';
import sl from '../resources/translations/sl-SI.json';
import 'regenerator-runtime/runtime';
import 'applib-frontend/dist/style.css';
import { connectLiveCaptions, closeLiveCaptions, emitter } from './live-captions';
import { version } from '../package.json';
const App = () => {
    const { connection } = useSession();
    const [projectId, setProjectId] = useState(0);
    const [captionsLoaded, setCaptionsLoaded] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    useEffect(() => {
        const { host } = window.location;
        void connectLiveCaptions(projectId, host, connection);
        emitter.once('connected', () => setCaptionsLoaded(false));
        emitter.once('newCaption', () => setCaptionsLoaded(true));
        return () => {
            closeLiveCaptions();
        };
    }, [projectId]);
    return (_jsxs(_Fragment, { children: [_jsx(StreamForm, { onNewStream: () => setShowVideo(false) }), _jsx(StreamTable, { onProjectId: setProjectId, captionsLoaded: captionsLoaded, onShowVideo: (show) => setShowVideo(show) }), showVideo ? (_jsx(MediaPlayer, { projectId: projectId })) : null] }));
};
const localization = new Localization({
    'en-US': en, 'pl-PL': pl, 'cs-CZ': cz, 'de-DE': de, 'hr-HR': hr, 'sk-SK': sk, 'sl-SI': sl,
}, 'en-US');
createRoot(document.querySelector('#app')).render(_jsx(BeeyApp, { name: "Stream", version: version, localization: localization, children: _jsx(App, {}) }));
